// import logo from './logo.svg';
// import Todo from './components/Todo';
// import Restaurant from './Restaurant/Restaurant';
// import Usestate from './hooks/Usestate';
// import Temp from './Weather/Temp';
import About from './portfolio/components/about/About';
import Header from './portfolio/components/header/Header';
import Navbar from './portfolio/components/nav/Navbar';
import Experience from './portfolio/components/experience/Experience';
import Services from './portfolio/components/services/Services';
import Testimonial from './portfolio/components/testimonials/Testimonial';
import Contact from './portfolio/components/contact/Contact';
import Footer from './portfolio/components/footer/Footer';
import './index.css';
import'./App.css';
function App() {
  return (
   
    <>
      {/* <Todo></Todo> */}
      {/* <Restaurant/> */}
      {/* <Usestate>
        
      </Usestate> */}
      {/* <Temp></Temp> */}
      <Header></Header>
      <Navbar></Navbar>
      <About></About>
      <Experience></Experience>
      <Services></Services>
      <Testimonial></Testimonial>
      <Contact></Contact>
      <Footer></Footer>
    </>
  );
}

export default App;
